import * as React from "react"

function Trash(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={22}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.6 5.657l-.934 13.091a2.156 2.156 0 01-2.151 2.003H5.592a2.156 2.156 0 01-2.15-2.003L2.505 5.658m5.391 4.312v6.47m4.313-6.47v6.47m1.078-10.782V2.422c0-.595-.483-1.078-1.078-1.078H7.897c-.595 0-1.078.483-1.078 1.078v3.235m-5.39 0h17.25"
        stroke="currentColor"
        strokeWidth={1.38623}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Trash